import React, { useState, useEffect } from 'react';
import { Card } from 'react-daisyui';
import { FileText } from 'react-feather';
import { Link } from 'react-router-dom';

const LatestTransactions = () => {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await fetch('https://berachain-v2-blacknodes-el-api.blacknodes.net/api/v2/main-page/transactions');
        const data = await response.json();
        const validTransactions = data
          .filter(tx => tx && tx.hash && tx.from?.hash && tx.to?.hash)
          .slice(0, 5);
        
        if (validTransactions.length > 0) {
          setTransactions(validTransactions);
        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
        // Silently handle the error - do nothing to keep old transactions
      }
    };

    fetchTransactions();
    const interval = setInterval(fetchTransactions, 12000);
    return () => clearInterval(interval);
  }, []);

  const formatAddress = (address) => {
    return address ? `${address.slice(0, 6)}...${address.slice(-4)}` : 'N/A';
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    const now = new Date();
    const txTime = new Date(timestamp);
    const diffSeconds = Math.floor((now - txTime) / 1000);
    return `${diffSeconds} secs ago`;
  };

  if (transactions.length === 0) {
    return (
      <Card className="bg-gray-900 border border-gray-800 shadow-[0px_20px_207px_10px_rgba(38,_126,_218,_0.93)] h-full">
        <Card.Body className="p-4 flex items-center justify-center">
          <p>Loading transactions...</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="bg-gray-900 border border-gray-800 shadow-[0px_20px_207px_10px_rgba(38,_126,_218,_0.93)] h-full">
      <Card.Body className="p-4 flex flex-col justify-between">
        <Card.Title tag="h2" className="text-xl mb-3">Latest Transactions</Card.Title>
        <div className="space-y-3 flex-grow">
          {transactions.map((tx) => (
            <div key={tx.hash} className="flex flex-col">
              <div className="flex items-center space-x-2 mb-1">
                <FileText size={16} className="text-cyan-400" />
                <Link 
                  to={`/tx/${tx.hash}`} 
                  className="text-cyan-400 hover:text-cyan-300 text-sm font-medium"
                >
                  {formatAddress(tx.hash)}
                </Link>
                <span className="text-gray-400 text-xs">{formatTimestamp(tx.timestamp)}</span>
              </div>
              <div className="flex justify-between text-xs">
                <div>
                  <span className="text-gray-400">From:</span>{' '}
                  <span className="text-white">{formatAddress(tx.from.hash)}</span>
                </div>
                <div>
                  <span className="text-gray-400">To:</span>{' '}
                  <span className="text-white">{formatAddress(tx.to.hash)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default LatestTransactions;